var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhy4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16341",
    "data-name": "Group 16341",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2091",
    "data-name": "Rectangle 2091",
    width: 39,
    height: 39,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(4.855 2.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8250",
    "data-name": "Path 8250",
    d: "M191.856,470a5,5,0,0,0,4.575-3h-9.151A5,5,0,0,0,191.856,470Z",
    transform: "translate(-177.167 -436.116)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8251",
    "data-name": "Path 8251",
    d: "M55.808,16.384V14.212a10.249,10.249,0,0,0-7.181-9.8V2.975a2.938,2.938,0,1,0-5.876,0V4.407a10.249,10.249,0,0,0-7.182,9.8v2.172a15.673,15.673,0,0,1-4.3,10.825,1,1,0,0,0-.194,1.075.979.979,0,0,0,.9.6H59.4a.979.979,0,0,0,.9-.6,1,1,0,0,0-.194-1.075A15.673,15.673,0,0,1,55.808,16.384Zm-9.14-12.37c-.322-.031-.649-.048-.979-.048s-.657.017-.979.048V2.975a.979.979,0,1,1,1.959,0Z",
    transform: "translate(-30.999)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8252",
    "data-name": "Path 8252",
    d: "M393.588,62.392a1,1,0,0,0,2,0A14.883,14.883,0,0,0,391.2,51.8a1,1,0,0,0-1.412,1.412A12.9,12.9,0,0,1,393.588,62.392Z",
    transform: "translate(-366.206 -48.078)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8253",
    "data-name": "Path 8253",
    d: "M32,63.392a1,1,0,0,0,1-1,12.9,12.9,0,0,1,3.8-9.181A1,1,0,0,0,35.388,51.8,14.883,14.883,0,0,0,31,62.393,1,1,0,0,0,32,63.392Z",
    transform: "translate(-31 -48.078)",
    fill: "#f9b316"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy4);
export default __webpack_public_path__ + "static/media/why4.674e5a473823d68de463bd607930eaa6.svg";
export { ForwardRef as ReactComponent };